import {
  buildDefaultLocalMapTranslationKey,
  IBuildType,
  IShow,
  LocalMapType,
} from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";
import { ENV_KEY_PREFIX } from "tools/localization/envKeyPrefix";

const localizeExhibitor = (
  show: Pick<IShow, "localMap"> | null | undefined,
  buildType: Pick<IBuildType, "exhibitorLocalMap"> | undefined,
  t: UseTranslateResult["t"]
) => {
  const translationKey =
    buildType?.exhibitorLocalMap?.translationKey ||
    show?.localMap?.exhibitorLocalMap?.translationKey ||
    buildDefaultLocalMapTranslationKey(ENV_KEY_PREFIX, LocalMapType.Exhibitor);

  return t(translationKey, { count: 1 });
};

export default localizeExhibitor;
